import { render, staticRenderFns } from "./WordCount.vue?vue&type=template&id=6788c87d&"
import script from "./WordCount.vue?vue&type=script&lang=js&"
export * from "./WordCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports